/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Encoding and decoding happen entirely in your browser — your text never leaves your device.`)
};

const es_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La codificación y decodificación ocurren completamente en tu navegador — tu texto nunca deja tu dispositivo.`)
};

const de_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Kodierung und Dekodierung finden vollständig in deinem Browser statt — dein Text verlässt dein Gerät niemals.`)
};

const nl_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Codering en decodering vinden volledig in uw browser plaats — uw tekst verlaat uw apparaat nooit.`)
};

const fr_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le codage et le décodage se font entièrement dans votre navigateur — votre texte ne quitte jamais votre appareil.`)
};

const it_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La codifica e la decodifica avvengono interamente nel tuo browser, il tuo testo non lascia mai il tuo dispositivo.`)
};

const pt_br2_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A codificação e decodificação ocorrem inteiramente no seu navegador — seu texto nunca sai do seu dispositivo.`)
};

const pt_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A codificação e descodificação acontecem inteiramente no seu navegador — o seu texto nunca sai do seu dispositivo.`)
};

const ja_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。エンコーディングとデコーディングはブラウザ内で完全に発生します—テキストはデバイスを離れません。`)
};

const zh_b64_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。编码和解码完全在您的浏览器中进行——您的文本永远不会离开您的设备。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_faq3_a", locale)
	if (locale === "en") return en_b64_faq3_a(inputs)
	if (locale === "es") return es_b64_faq3_a(inputs)
	if (locale === "de") return de_b64_faq3_a(inputs)
	if (locale === "nl") return nl_b64_faq3_a(inputs)
	if (locale === "fr") return fr_b64_faq3_a(inputs)
	if (locale === "it") return it_b64_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_b64_faq3_a(inputs)
	if (locale === "pt") return pt_b64_faq3_a(inputs)
	if (locale === "ja") return ja_b64_faq3_a(inputs)
	return zh_b64_faq3_a(inputs)
};